import { render, staticRenderFns } from "./V2-0-0.vue?vue&type=template&id=4eff8d49&scoped=true&"
import script from "./V2-0-0.vue?vue&type=script&lang=js&"
export * from "./V2-0-0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff8d49",
  null
  
)

export default component.exports